import {
  ChevronLeftIcon,
  DotsHorizontalIcon,
  UserCircleIcon,
} from "@heroicons/react/solid";
import { BookmarkIcon } from "@heroicons/react/solid";
import React, { useState, useEffect } from "react";
import Table from "../../parts/table/Table";
import illustrasi from "../../assests/img/illustrasi/illustrasi-hasil-kuis.svg";
import styled from "styled-components";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
  Link,
  useParams,
} from "react-router-dom";
import SMSelect from "../../elements/select/SMSelect";
import axiosAPI from "../../utils/axios-api";
import HasilKuisDetailLikert from "./detail/HasilKuisDetailLikert";
import HasilKuisDetailPilihanGanda from "./detail/HasilKuisDetailPilihanGanda";
import HasilKuisDetailFile from "./detail/HasilKuisDetailFile";
import DownloadPilihanGanda from "./detail/Excel/DownloadPilihanGanda";
import DownloadLikert from "./detail/Excel/DownloadLikert";

const API = process.env.REACT_APP_API;

const HasilKuesioner = () => {
  let { idKuesioner } = useParams();
  let { path } = useRouteMatch();
  const [selectedDetail, setselectedDetail] = useState(null);
  const [dataKuesioner, setdataKuesioner] = useState({});
  const [dataSoal, setdataSoal] = useState([]);
  const [jumlahSoal, setjumlahSoal] = useState(0);
  const [detailHasilKuis, setDetailHasilKuis] = useState(0);

  // data soal liklert
  const [dataLiklert, setdataLiklert] = useState([]);
  const [jumlahSoaLiklert, setjumlahSoaLiklert] = useState(null);
  const [dataSkalaLiklert, setdataSkalaLiklert] = useState([]);
  const [kategoriLiklert, setkategoriLiklert] = useState(0);

  const [loadingGetData, setloadingGetData] = useState(false);

  const [loading, setloading] = useState(0);

  useEffect(() => {
    setloadingGetData(true);
    getDetail();
    getDetailSoal();
    setDetailHasilKuis();
  }, []);

  function getDetail(params) {
    axiosAPI
      .get(API + "kuesioner/" + idKuesioner + "?include=dataSoal")
      .then((res) => {
        let data = res.data.data;
        setdataKuesioner(data);
        if (data.tipe === 2) {
          setdataLiklert(data.relationships.dataSoal);
          setjumlahSoaLiklert(data.relationships.jumlah_soal);
          setdataSkalaLiklert(data.relationships.dataSkala);
          setkategoriLiklert(data.relationships.dataKategori);
        } else if (data.tipe === 0) {
          setdataSoal(data.relationships.dataSoal);
        } else {
          setdataSoal(data.relationships.dataSoal);
        }
      })
      .catch((err) => {
        setloadingGetData(false);
      });
  }

  function getDetailSoal(params) {
    axiosAPI
      .get(
        API +
          "rekap/" +
          idKuesioner +
          "/detail-kuesioner?page[size]=10&page[number]=1&filter[users.nama]="
      )
      .then((res) => {
        setdataSoal(res.data.data);
        setjumlahSoal(res.data.jumlah_soal);
        setDetailHasilKuis(res.data)
        setloadingGetData(false);
      });
  }

  function _mainRender(params) {
    return (
      <div className="flex flex-col flex-1">
        <div className="flex flex-row my-4 justify-between">
          {/* <div className="flex flex-row w-32">
            <SMSelect />
          </div> */}

          <div className="flex">
            {loadingGetData ? null : (
              <DownloadPilihanGanda
                dataKuesioner={dataKuesioner}
                dataSoal={dataSoal}
                jumlahSoal={jumlahSoal}
              />
            )}
          </div>
        </div>
        {loadingGetData ? null : (
          <HasilKuisDetailPilihanGanda
            dataSoal={dataSoal}
            jumlahSoal={jumlahSoal}
          />
        )}
        {/* <Table columns={columns} data={dataSoal} /> */}
      </div>
    );
  }

  function _detailRender(params) {
    const DivDetail = styled.div`
      display: grid;
      grid-template-columns: repeat(20, auto);
      grid-gap: 2px;
    `;
    return (
      <div>
        <div className="flex mb-6 flex-row items-center">
          <button onClick={() => window.history.back()}>
            <ChevronLeftIcon className="w-6 h-6" />
          </button>
          <UserCircleIcon className="w-6 h-6 mx-3" />
          <h1>{selectedDetail}</h1>
        </div>

        <DivDetail>
          {[...Array(40).keys()].map((elmnt) => {
            return (
              <div key={elmnt} className="flex flex-col text-center">
                <div className="p-2 bg-blue-400">1</div>
                <div className="p-2 text-gray-900 bg-gray-200">1</div>
              </div>
            );
          })}
        </DivDetail>
      </div>
    );
  }

  function _renderType(params) {
    if (dataKuesioner.tipe === 0) {
      return (
        <Router>
          <Switch>
            <Route path={path} exact>
              <div className="flex">{_mainRender()}</div>
            </Route>
            <Route path={`${path}/:slug`} exact>
              <div className="flex flex-col">{_detailRender()}</div>
            </Route>
          </Switch>
        </Router>
      );
    } else if (dataKuesioner.tipe === 1) {
      return (
        <>
          {loadingGetData ? null : <HasilKuisDetailFile dataSoal={dataSoal} detailHasilKuis={detailHasilKuis} />}
        </>
      );
    } else if (dataKuesioner.tipe === 2) {
      return (
        <>
          {loadingGetData ? null : (
            <>
              <div className="flex flex-row my-4 justify-between">
                <div className="flex flex-row w-32">
                  {/* <SMSelect /> */}
                </div>

                <div className="flex">
                  {loadingGetData ? null : (
                    <DownloadLikert
                      dataKuesioner={dataKuesioner}
                      dataSoal={dataSoal}
                      jumlahSoal={jumlahSoal}
                    />
                  )}
                </div>
              </div>
              <HasilKuisDetailLikert
                dataSoal={dataSoal}
                dataSkala={dataSkalaLiklert}
                kategori={kategoriLiklert}
                jumlahSoal={jumlahSoaLiklert}
                detailHasilKuis={detailHasilKuis}
              />
            </>
          )}
        </>
      );
    }
  }
  return (
    <div
      className="w-full flex flex-col p-10 dark:text-white"
      style={{ minHeight: "100vh" }}
    >
      <div className="block mb-8">
        <div className="flex flex-col">
          <h1 className="text-3xl font-bold mr-4 my-6">
            Detail Hasil Kuis - {dataKuesioner?.judul}
          </h1>

          <div className="flex flex-row p-4 py-10 rounded-lg bg-gradient-to-r from-blue-400 via-indigo-600 to-purple-500 text-white">
            <div className="flex w-3/12 items-center justify-center">
              <img src={illustrasi} alt="" />
            </div>
            <div className="flex flex-col w-9/12">
              <span className="flex flex-row items-center my-2">
                <BookmarkIcon className="h-6 w-6 mr-1" />
                <p>{(dataKuesioner.tipe === 0) ? "Pilihan Ganda" : (dataKuesioner.tipe === 1) ? "File" : "Liklert"}</p>
              </span>
              <h1 className="text-3xl font-bold">{dataKuesioner?.judul}</h1>
              <p>{dataKuesioner?.keterangan}</p>
              <p>
                {dataKuesioner?.tanggal_buka} - {dataKuesioner?.tanggal_tutup}
              </p>

              <div className="flex my-3">
                <a href={dataKuesioner?.file_panduan} download target="_blank" className="px-4 py-2 border border-white rounded">
                  <p className="text-white">Download file panduan</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {_renderType()}
    </div>
  );
};

export default HasilKuesioner;
